import React, { useState, useEffect } from "react";
import "./DiscountCode.css";
import MainInput from "../../Elements/MainInput/MainInput";

const DiscountCode = ({ onApply, promocodeData, promocodeError }) => {
  const [code, setCode] = useState("");
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState("");
  const [isApplying, setIsApplying] = useState(false);

  useEffect(() => {
    if (!!promocodeData) {
      setStatus("success");
      setMessage("Applied!");
    } else if (promocodeError) {
      setStatus("error");
      setMessage(promocodeError);
    } else {
      setStatus(null);
      setMessage("");
    }
  }, [promocodeData, promocodeError]);

  const handleApply = async () => {
    const trimmed = code.trim();
    if (!trimmed) return;

    setStatus(null);
    setMessage("");

    try {
      await onApply(trimmed);
    } catch (err) {
      setStatus("error");
      setMessage("Invalid code");
    }
  };

  return (
    <div className="discount-wrapper">
      <div className="discount-input-box">
        <MainInput
          value={code}
          onChange={(e) => {
            setCode(e.target.value);
            setStatus(null);
            setMessage("");
          }}
          placeholder="Discount code"
          name="discountCode"
        />

        <button className="offers-toggle-btn discount-apply-btn" type="button" onClick={handleApply}>
          Apply Code
        </button>
        {message && (
          <span
            className={
              status === "success"
                ? "discount-message discount-message--success"
                : "discount-message discount-message--error"
            }
          >
            {message}
          </span>
        )}
      </div>
    </div>
  );
};

export default DiscountCode;
